import React from 'react';
import { kumbhMelaInfo, RAILS_KUMBH_MELA_FAQS } from './kumbh_mela_special_trains_data';
import { crawlerDuplicateAvoidStyle } from '../../utils/commonUtils';
import FaqSection from '../components/FaqSection';

const KumbhMelaInfo = () => {
  return (
    <div className={'infoCard'}>
      <h2 style={crawlerDuplicateAvoidStyle} className="mobileShow font22 appendBottom15 latoLight">
        {`Check Out the Kumbh Mela Special Trains - 2025`}
      </h2>
      {kumbhMelaInfo.map(({ title, html }, index) => {
        return (
          <div className={'appendBottom20 darkGreyText'} key={index}>
            {title ? <h2 className={'appendBottom10 latoBold blackText appendBottom5'}>{title}</h2> : null}
            <div dangerouslySetInnerHTML={{ __html: html }} key={index}></div>
          </div>
        );
      })}
      <div className="appendTop10">
        <FaqSection faq={RAILS_KUMBH_MELA_FAQS.list} title={RAILS_KUMBH_MELA_FAQS.title} />
      </div>
    </div>
  );
};

export default KumbhMelaInfo;
